import {ITransactionRequest} from '../../interfaces/transaction-request.interface';
import {ITransaction} from '../../interfaces/transaction.interface';
import {IAmendTransaction} from '../../interfaces/amend-transaction.interface';
import {IAlertMessage} from '../../interfaces/alert-message.interface';
import { ITransactionSearchCriteria } from '../../interfaces/search-criteria';
import { IPendingTransaction } from '../../interfaces/pending-transaction.interface';
import { IUpdateTransactionDateRequest } from '../../interfaces/update-transaction-date-request.interface';
import { ITransactionModel } from '../../interfaces/ITransactionModel';
import { IBulkVerifyRequest } from 'src/app/dashboard/interfaces/IBulkVerifyRequest';
import { ICreateCompoundRequest } from 'src/app/inventory/interfaces/create-compound-request';
import { IReceiveCompoundRequest } from 'src/app/inventory/interfaces/receive-compound-request.interface';
import { ICompoundAmendRequestPayload } from '../../interfaces/compound-amend-request.interface';

export class GetDashboardSummary {
  static readonly type = '[Transactions] get dashboard summary information';
}

export class SetWidgetData {
  static readonly type = '[Transactions] set main data for right-side widget';

  constructor(public data: ITransaction) {
  }
}

export class SetDrugTransactions {
  static readonly type = '[Transactions] set transactions for current inventory for searching purposes';

  constructor(public transactions: ITransaction[]) {
  }
}

export class GetInventoryTransactions {
  static readonly type = '[Transactions] get inventory transactions by id';

  constructor(public drugID: string) {
  }
}

export class GetAllTransactionsWithDetails {
  static readonly type = '[Transactions] get all transactions for current user';

  constructor(public criteria: any) {
  }
}

export class GetAllTransactionsWithoutDetails {
  static readonly type = '[Transactions] Get All Transactions Without Details';

  constructor(public criteria: any) {
  }
}

export class SetTransactionsList {
  static readonly type = '[Transactions] set transactions for sorting purposes';

  constructor(public transactions: ITransaction[]) {
  }
}

export class GetAmendReasonsList {
  static readonly type = '[Transactions] get reasons list for amending';
}

export class GetWidgetHistory {
  static readonly type = '[Transactions] get most recent 5 transactions for a given drug';

  constructor(public drugId: string) {
  }
}

export class SetTransaction {
  static readonly type = '[Transactions] save the transaction to the store';

  constructor(public transaction: ITransaction) {
  }
}

export class GetTransaction {
  static readonly type = '[Transactions] get one transaction by id';

  constructor(public id: string, public shouldOpenWidget: boolean = true) {
  }
}

export class CreateTransaction {
  static readonly type = '[Transactions] create transaction';

  constructor(public transactions: ITransactionRequest[]) {
  }
}

export class UpdateTransactionDate {
  static readonly type = '[Transactions] update transaction date';
  constructor(public payload: IUpdateTransactionDateRequest) {
  }
}

export class GetTransactionDateHistory {
  static readonly type = '[Transactions] get transaction date history';
  constructor(public transactionId: string) {
  }
}

export class AmendTransaction {
  static readonly type = '[Transactions] amend current transaction by id';

  constructor(public amendData: IAmendTransaction, public id: string, public friendlyName: string, public packageNdc: string) {
  }
}
export class GetPendingTransactions {
  static readonly type = '[Transactions] get all unconfirmed transactions by pharmacy id';

  constructor() {
  }
}

export class GetPendingTransactionDetails {
  static readonly type = '[Transactions] get pending transaction details';

  constructor(public id: number) {
  }
}

export class RefreshPendingTransactionDetails {
  static readonly type = '[Transactions] refresh pending transaction details';

  constructor(public id: number) {
  }
}

export class ConfirmTransaction {
  static readonly type = '[Transactions] confirm pending transaction';

  constructor(public payload: any) {
  }
}
export class ConfirmSplitNdcsDispense {
  static readonly type = '[Transactions] confirm pending transaction dispense with split ndcs';

  constructor(public payload: any) {
  }
}

export class ConfirmSplitNdcsAmendment {
  static readonly type = '[Transactions] confirm pending transaction amendment with split ndcs';

  constructor(public payload: any) {
  }
}

export class InvalidateTransaction {
  static readonly type = '[Transactions] mark transaction as invalid';

  constructor(public payload: any) {
  }
}
export class SetCarouselDisplayList {
  static readonly type = '[Transactions] set carousel display list ';

  constructor(public pendingTransactions: IPendingTransaction[]) {
  }
}

export class AddPendingTransaction {
  static readonly type = '[Transactions] add a created pedning transaction';

  constructor(public pendingTransaction: IPendingTransaction) {
  }
}

export class UpdatePendingTransaction {
  static readonly type = '[Transactions] update a pedning transaction';

  constructor(public pendingTransaction: IPendingTransaction) {
  }
}

export class DeletePendingTransactionFromView {
  static readonly type = '[Transactions] delete a pedning transaction';

  constructor(public id: number) {
  }
}

export class GetMostRecentAuditTransactionDate {
  static readonly type = '[Transactions] get most recent audit transaction date';

  constructor(public drugId: string, public locationId: string) {
  }
}

export class ValidateTransactionDateForPendingTransactionAmend {
  static readonly type = '[Transactions] Validate Transaction Date For Pending Transaction Amend';

  constructor(public payload) {
  }
}

export class TestForDupTransactions {
  static readonly type = '[Transactions] Test For Duplicate Transactions';

  constructor(public payload) {
  }
}

export class MarkPendingTransactionAsConfirmed {
  static readonly type = '[Transactions] Mark Pending Transaction As Confirmed';

  constructor(public payload) {
  }
}

export class SetTransactionsForScroll {
  static readonly type = '[Transactions] Set Transactions For Scroll';

  constructor(public transactions: ITransactionModel[]) {
  }
}

export class SetDashboardFilters {
  static readonly type = '[Transactions] Set Filters From Dashboard Table';

  constructor(public filters: any) {
  }
}

export class SetCurrentPage {
  static readonly type = '[Transactions] Set Current Page';

  constructor(public page: number) {
  }
}


export class GetUnconfirmedPendingDispenseOwedQuantity {
  static readonly type = '[Transactions] Get Unconfirmed Pending Dispense Owed';

  constructor(public rxNumber: string, public refillNumber: number) {
  }
}

export class CloseNoNeedToConfirmOwedDialogAndRemoveCard {
  static readonly type = '[Transactions] Close No Need To Confirm Owed Dialog And Remove Card';

  constructor() {
  }
}


export class GetPendingTransactionsForBulkVerify {
  static readonly type = '[Transactions] Get Pending Transactions For Bulk Verify';

  constructor(public locationID?: string) {
  }
}

export class BulkVerifyValidateNdcTransactionDate {
  static readonly type = '[Transactions] Bulk Verify Validate Ndc Transaction Date';

  constructor(public payload: any) {
  }
}

export class BulkVerify {
  static readonly type = '[Transactions] Bulk Verify';

  constructor(public payload: IBulkVerifyRequest) {
  }
}

export class SetBulkVerifyLoadedPercent {
  static readonly type = '[Transactions] Set Bulk Verify Loaded Percent';

  constructor(public percent: number) {
  }
}

export class IsBulkVerifyInProgress {
  static readonly type = '[Transactions] Is Bulk Verify In Progress';

  constructor() {
  }
}

export class ResetPotentialsDuplicates {
  static readonly type = '[Transactions] Reset Potentials Duplicates';

  constructor() {
  }
}

export class ClearPendingTransactions {
  static readonly type = '[Transactions] Clear Pending Transactions';

  constructor() {
  }
}

export class GetCompounds {
  static readonly type = '[Transactions] Get Compounds';

  constructor() {
  }
}

export class CreateCompound {
  static readonly type = '[Transactions] Create Compound';

  constructor(public request: ICreateCompoundRequest) {
  }
}

export class ReceiveCompound {
  static readonly type = '[Transactions] Receive Compound';

  constructor(public request: IReceiveCompoundRequest) {
  }
}


export class GetCompoundDetails {
  static readonly type = '[Transactions] Get Compound Details';

  constructor(public id: string) {
  }
}

export class GetAmendIngredientsWaste {
  static readonly type = '[Transactions] Get Amend Ingredients Waste';

  constructor(public id: string) {
  }
}

export class AmendCompound {
  static readonly type = '[Transactions] Amend Compound';

  constructor(public request: ICompoundAmendRequestPayload) {
  }
}

export class GetIngredientsFromTheLatestCompounding {
  static readonly type = '[Transactions] Get Ingredients From The Latest Compounding';

  constructor(public drugId: string) {
  }
}


export class ConfirmTheCombinedOwedAndSplitDispense {
  static readonly type = '[Transactions] Confirm The Combined Owed And Split Dispense';

  constructor(public payload: any) {
  }
}


